import { atom } from "recoil"

export const organizationMembersRequestIdState = atom<number>({
  key: "atoms/organization/organizationMembersRequestIdState",
  default: 0,
})
